import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
  imports: [CommonModule,MatFormFieldModule,MatInputModule],
  standalone: true,
  selector: 'app-key-deliverable',
  templateUrl: './key-deliverable.component.html',
  styleUrls: ['./key-deliverable.component.css'],
})
export class KeyDeliverableComponent {
  @Input() keyDeliverable: any[] = [];
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  addKeyDeliverable(inputField: HTMLInputElement): void {
    const keywordName = inputField.value.trim();
    if (
      keywordName &&
      !this.keyDeliverable.some((k) => k.name === keywordName)
    ) {
      const newKeyword = {
        id: Math.floor(Math.random() * 1000),
        project_id: 7,
        name: keywordName,
      };
      this.keyDeliverable.push(newKeyword);
    }

    inputField.value = '';
  }
  removekeyDeliverable(keyword: {
    id: number;
    project_id: number;
    name: string;
  }): void {
    this.keyDeliverable = this.keyDeliverable.filter(
      (k) => k.name !== keyword.name
    );
  }

  save() {
    this.onSave.emit(this.keyDeliverable);
  }

  cancel() {
    this.onCLose.emit();
  }
}
